/* eslint-disable */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-feedback',
  templateUrl: './browser-feedback.page.html',
  styleUrls: ['./browser-feedback.page.scss']
})
export class BrowserFeedbackPage implements OnInit {
  constructor() {}

  ngOnInit() {}
}
